<template>
  <div class="blog-promo-banner" v-if="visible">
    <div class="blog-promo-banner__inner">
      <img
        class="blog-promo-banner__image"
        :src="require('@/assets/images/ebooks/smb-marketing-blueprint-hero.webp')"
        alt=""
      />
      <div class="blog-promo-banner__copy">
        <h3 class="blog-promo-banner__title">The SMB marketing blueprint</h3>
        <p class="blog-promo-banner__text">
          How to improve visibility, stay consistent, and win repeat customers.
        </p>
      </div>
      <a
        href="https://transpond.io/ebooks/smb-marketing-blueprint/"
        title="Download your copy"
        class="btn btn--primary btn--sm blog-promo-banner__cta"
        >Download your copy</a
      >
      <button
        class="blog-promo-banner__close"
        title="Dismiss"
        aria-label="Dismiss"
        type="button"
        v-on:click="dismiss"
      >
        &times;
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "BlogPromoBanner",
  data() {
    return {
      visible: true,
    };
  },
  methods: {
    dismiss() {
      this.visible = false;
    },
  },
};
</script>
